import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {BrukerRessurs} from "../../../../../felles/tjenester/ressurser/BrukerRessurs";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import _ from "lodash";

const css = require('./bekreftMobilnummer.scss');

export class BekreftModilnummerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmBrukerBekreftMobilnummer', {
                bindings: {
                    vedFerdig: '&',
                    vedAvbryt: '&'
                },
                controller: BekreftModilnummerKontroller.forInjisering(),
                template: require('./bekreftMobilnummer.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            BrukerRessurs.regNavn,
            Kontekst.regNavn,
            BekreftModilnummerKontroller
        ]
    }

    constructor(private $scope: IScope,
                private brukerRes: BrukerRessurs,
                private kontekst: Kontekst) {
    }

    vedFerdig: Function; //settes via bindings
    vedAvbryt: Function; //settes via bindings

    smsOtpAktivert = false;
    lagrer = false;
    otpKode: string;
    otpSendtTil: string;
    oppsettBekreftet: l.ValideringResponsModell;

    steg: 'sendkode' | 'oppgikode' | 'kvittering' = 'sendkode';

    sendOtp() {
        this.brukerRes.sendBekreftMobilnummerOtp().$promise
            .then(respons => {
                this.otpSendtTil = respons.otpSendtTil;
                this.steg = 'oppgikode';
            })
    }

    otpValidert() {
        //console.debug('otpValidert', this.oppsettBekreftet);
        if (!this.oppsettBekreftet) return undefined;
        return this.oppsettBekreftet.validert;
    }

    otpOppdatert() {
        //console.debug('otpOppdatert', this.totpKode);
        this.oppsettBekreftet = null;
    }

    validerOtp() {
        this.lagrer = true;
        this.brukerRes.bekreftMobilnummerOtp(this.otpKode).$promise
            .then(oppsettBekreftet => {
                this.oppsettBekreftet = oppsettBekreftet;
                if (!this.oppsettBekreftet.validert) return;

                this.kontekst.relastBruker();
                this.gaaTilVisKvittering();
            })
            .finally(() => this.lagrer = false);
    }

    gaaTilVisKvittering() {
        this.steg = 'kvittering';
    }

    lukk() {
        this.vedFerdig();
    }

    avbryt() {
        this.vedAvbryt();
    }

    $onInit(): void {
        this.smsOtpAktivert = _.includes(this.kontekst.autentisertBruker().autentiseringsmetoder, l.Autentiseringsmetode.smsOtp);
    }

}
